import type { SeriesAreaOptions } from 'highcharts';

const greenFillColor = 'rgba(79, 191, 64, 0.15)';
const redFillColor = 'rgba(255, 68, 45, 0.15)';

export const makeChartOptions = (chartData: number[], changeData: number[], fillColor: 'green' | 'red' | null) => {
  const chartWidth = 320;
  const trafficData = chartData.length === 1 ? [chartData[0], chartData[0]] : chartData;
  const series: SeriesAreaOptions[] = [{ name: 'Traffic', type: 'area', data: trafficData }];
  if (changeData.length > 0 && !!fillColor) {
    series.push({
      name: 'Change',
      type: 'area',
      data: changeData,
      fillColor: fillColor === 'green' ? greenFillColor : redFillColor,
    });
  }

  return {
    title: { text: undefined },
    yAxis: { visible: false },
    xAxis: { visible: false },
    legend: { enabled: false },
    tooltip: { enabled: false },
    credits: { enabled: false },
    chart: { type: 'area', height: 62, width: chartWidth, spacing: [0, 0, 0, 0] },
    plotOptions: {
      area: {
        color: '#3E74FE',
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0.3152, 'rgba(79, 141, 249, 0.12)'],
            [1, 'rgba(79, 141, 249, 0.02)'],
          ],
        },
        marker: { enabled: false, states: { hover: { enabled: false } } },
        enableMouseTracking: false,
      },
    },
    series,
  };
};
